/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $, SCS) {
	'use strict';

	var KEYS = {
		ESCAPE: 27,
		DOWN: 40,
		UP: 38,
		ENTER: 13
	};
	var PROCESS_WAIT_TIMEOUT = 200;

	function stop(event) {
		event.preventDefault();
	}

	function getSelectedSuggestion(mod) {
		if(mod.selectedIndex in mod.suggestions) {
			return mod.suggestions[mod.selectedIndex];
		}
		return null;
	}

	// Click handler for a suggest item
	function activateSuggestion(mod, suggestion) {
		// Tracking
		Module.SearchResultContainer.trackClick('suggestion', mod.suggestConfig, suggestion, mod.searchProcessor);
		// Set the form value and let the submit handle the rest
		mod.$field.val(suggestion.name);
		mod.$form.submit();
	}

	function updateSelectedIndex(mod, index) {
		mod.selectedIndex = index;
		updateDom(mod);
	}

	function selectionChanged(mod, delta) {
		var newSelectedIndex = mod.selectedIndex + delta;
		if(newSelectedIndex < -1) {
			// On arrow-up, if nothing is selected, select the last item available
			newSelectedIndex = mod.suggestions.length + newSelectedIndex + 1;
		}
		if(newSelectedIndex >= mod.suggestions.length) {
			// On arrow-down at the last item, begin again with being unselected
			newSelectedIndex = -1;
		}
		updateSelectedIndex(mod, newSelectedIndex);
	}

	function updateDom(mod) {
		var selectedSuggestion = getSelectedSuggestion(mod);
		var results = mod.suggestions;
		var snabbdom = window.snabbdom;
		var h = snabbdom.h;
		var contents = [];
		for(var i=0;i<results.length;i+=1) {
			var result = results[i];
			contents.push(h(
				'li.scs-sitesearch-autosuggest-li',
				{
					'class': {
						'scs-sitesearch-searchfield-hoveractive': result === selectedSuggestion
					},
					on: {
						click: [activateSuggestion, mod, result],
						// Don’t let the mousedown trigger a blur of the input field (otherwise we don’t get a click)
						mousedown: stop
					}
				},
				result.name
			));
		}

		var suggestions = h('ul.suggestions', contents);
		mod.suggestResultContent = snabbdom.patch(mod.suggestResultContent, suggestions);
		mod.$instantResultContainer.toggleClass('has-results', !!results.length);

		if(selectedSuggestion) {
			mod.$field.val(selectedSuggestion.name);
		} else {
			mod.$field.val(mod.prevFieldVal);
		}
	}

	function suggestData(processor, data, config) {
		// jshint validthis: true
		this.selectedIndex = -1;
		this.suggestions = data.results || [];
		this.suggestConfig = config;
		updateDom(this);
	}

	function suggestError() {
		// jshint validthis: true
		this.selectedIndex = -1;
		this.suggestions = [];
		updateDom(this);
	}

	function setupSuggestions(mod, $field, $form) {
		var numberOfSuggestions = parseInt($field.attr('data-sitesearch-gsanumberofresults'), 10);
		if(!numberOfSuggestions) {
			return;
		}
		mod.$instantResultContainer = mod.$ctx.find('.scs-sitesearch-searchfield-autosuggest');
		if(!mod.$instantResultContainer.length) {
			return;
		}

		$field.attr('autocomplete', 'off');
		mod.$field = $field;
		mod.$form = $form;

		mod.searchProcessor = SCS.search.orchestration.forAutosuggest(
			$field.attr('data-sitesearch-gsahostname'),
			$field.attr('data-sitesearch-sites'),
			$field.attr('data-sitesearch-client'),
			$field.attr('gsanumberofresults'),
			0, // No keymatches
			$('html').attr('lang') || 'de'
		);
		mod.searchProcessor.responder(SCS.search.util.respondTo({
			'data': $.proxy(suggestData, mod),
			'error': $.proxy(suggestError, mod)
		}, mod));


		$field.on('keydown', function(event) {
			if(event.keyCode === KEYS.UP) {
				selectionChanged(mod, -1);
			} else if(event.keyCode === KEYS.DOWN) {
				selectionChanged(mod, +1);
			} else {
				return;
			}
			// Do not further process the key press:
			// * Do not trigger a new search
			// * Do not move the cursor the beginning or end when navigating suggestions or keymatches
			event.stopImmediatePropagation();
			return false;
		});
		var processKeyPressTimeout = null;

		$field.on('input keypress', function(event) {
			if(event.which === KEYS.ENTER) {
				// Selected suggestions already updated the field value with the suggestion
				// and normal searches can just trigger the regular form submit
				return;
			}
			var value = $field.val();
			if(value === mod.prevFieldVal) {
				return;
			}

			mod.prevFieldVal = value;

			clearTimeout(processKeyPressTimeout);
			processKeyPressTimeout = setTimeout(function() {
				processKeyPressTimeout = null;
				mod.searchProcessor.process({query: value});
			}, PROCESS_WAIT_TIMEOUT);
		});

		$field.on('focus', function() {
			mod.$instantResultContainer.addClass('focused');
		}).on('blur', function() {
			mod.$instantResultContainer.removeClass('focused');
		});

		mod.suggestResultContent = $('<ul/>').appendTo(mod.$instantResultContainer)[0];
	}

	// For the legacy header
	var HeaderSearchQueryForm = Module.extend({
		// The currently-selected suggestion
		selectedIndex: -1,
		// The list of suggestions
		suggestions: [],
		// The configuration for the suggest request
		suggestConfig: {},
		// The previous search value (before overwriting the search field with the text from the selected suggestion)
		prevFieldVal: '',

		on: function(callback) {
			callback();
		},

		after: function() {
			this.attachListeners();
		},

		attachListeners: function() {
			var $form = this.$ctx;
			var $field = $form.find('input[name="q"]');
			$form.on('submit', function(event) {
				event.preventDefault();
				var target = $form.attr('action');
				var pivot = '#'; // RESOLVE: Do we need to use query params at one point or is the hash always ok?
				var separator = target.indexOf(pivot) > -1 ? '&' : pivot;
				var query = {query: $field.val()};
				target = target + separator + SCS.search.util.param(query);
				window.location.href = target;
			});

			var $toggleIcon = $form.closest('.modMobileHeader').find('.scs-sitesearch-icon');
			$toggleIcon.click(function() {
				$toggleIcon.toggleClass('scs-sitesearch-active-icon');
				if($toggleIcon.hasClass('scs-sitesearch-active-icon')) {
					$form.slideDown('fast');
				} else {
					$form.slideUp('fast');
				}
			});

			// custom event fired by scsSiteSearch.Serp.init()
			$(document).on('scsSiteSearch-serp-query', function (event, q) {
				// we are on a search result page (SERP)

				$toggleIcon.removeClass('scs-sitesearch-active-icon').click();
				$field.val(q);
			});

			setupSuggestions(this, $field, $form);
		}
	});

	Module.HeaderSearchQueryForm = HeaderSearchQueryForm;

})(window.Tc.Module, window.Tc.$, window.SCS = window.SCS || {});

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.HeaderSearchQueryForm.js
// module id = 54
// module chunks = 0